import React, { Component } from 'react'

import greenCheck from '../../../assets/images/green-check.svg'
import { Card } from '../../../components/card'
import { utcToLocalDateTime } from '../../../helpers/timeHelper'
import { displaySnakeCaseAsTitleCase } from '../../../helpers/displayFormatHelper'
import { BankAccount } from '../../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props extends BankAccount {
  deleteAccount: Callback
}

export class MicroCard extends Component<Props> {
  static displayName = 'MicroCard'

  render() {
    const {
      id,
      verifiedAt,
      verified,
      bankName,
      accountNumber,
      accountType,
      routingNumber,
      deletable,
      deleteAccount,
      createdAt,
      microdepositsSentAt,
      microdepositsSent,
      microdepositAmounts,
    } = this.props

    let amounts = '--'
    if (microdepositAmounts.length > 0) {
      const deposits = microdepositAmounts.map((int) => {
        return `$${Number(int).toFixed(2)}`
      })
      amounts = deposits.join(' / ')
    }

    return (
      <Card title="Bank" gridClass="user-bank-accounts">
        <div className="user-bank-accounts__title">
          <p className="user-bank-accounts__bank-name">{bankName}</p>
          {verified ? (
            <img
              className="user-bank-accounts__verified-icon"
              src={greenCheck}
            />
          ) : null}
        </div>
        {verified ? (
          <p className="user-bank-accounts__content">
            Verified by: Microdeposit
          </p>
        ) : (
          <p className="user-bank-accounts__content">Pending: Microdeposit</p>
        )}
        {verified ? (
          <p className="user-bank-accounts__content">
            Date: {utcToLocalDateTime(verifiedAt)}
          </p>
        ) : (
          <p className="user-bank-accounts__content">
            Initiated: {utcToLocalDateTime(createdAt)}
          </p>
        )}
        {!verified && microdepositsSent ? (
          <p className="user-bank-accounts__content">
            ACH sent: {utcToLocalDateTime(microdepositsSentAt)}
          </p>
        ) : null}
        {!verified && !microdepositsSent ? (
          <p className="user-bank-accounts__content">ACH not sent</p>
        ) : null}
        {microdepositAmounts.length > 1 ? (
          <p className="user-bank-accounts__content">Amounts: {amounts}</p>
        ) : (
          <p className="user-bank-accounts__content">Amount: {amounts}</p>
        )}
        {accountType ? (
          <p className="user-bank-accounts__content">
            Type: {displaySnakeCaseAsTitleCase(accountType)}
          </p>
        ) : (
          <p className="user-bank-accounts__content">Type:</p>
        )}
        <p className="user-bank-accounts__content">
          Account #:{' '}
          {accountNumber.replace(
            /\*+/i,
            '\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF'
          )}{' '}
        </p>
        <p className="user-bank-accounts__content">
          Routing #: {routingNumber}
        </p>
        <div className="user-bank-accounts__footer">
          {deletable ? (
            <a
              className="button button--link-text user-bank-accounts__footer-link"
              onClick={() => deleteAccount(id)}
            >
              Delete bank account
            </a>
          ) : (
            <p className="user-bank-accounts__footer-message">In Transaction</p>
          )}
        </div>
      </Card>
    )
  }
}

export default MicroCard
